import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getAllPlans,
  getAllAttPlans,
  getAllTracfonePlans,
  getAllSimoPlans,
  getAllQuickPlans,
} from 'reducers';
import { fetchAllPlans as fetchAttPlans } from 'actions/attPlans';
import { fetchAllPlans } from 'actions/plans';
import { fetchAllPlans as fetchTracfonePlans } from 'actions/tracfonePlans';
import { fetchAllPlans as fetchSimoPlans } from 'actions/simoPlans';
import { fetchAllPlans as fetchQuickPlans } from 'actions/quickPlans';

const withPlans = (
  DecoratedComponent,
  getPlans,
  fetchPlansAction,
  fetchPlanParams = {},
) => {
  class WithPlans extends Component {
    componentDidMount() {
      this.fetchPlans();
    }

    fetchPlans() {
      const { fetchPlans, subId } = this.props;
      fetchPlans({ ...fetchPlanParams, subscription_id: subId });
    }

    render() {
      const { children, ...props } = this.props;

      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapStateToProps = (state) => ({
    plans: getPlans(state),
  });

  const mapDispatchToProps = {
    fetchPlans: fetchPlansAction,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithPlans);
};

export const withAttPlans = (DecoratedComponent) =>
  withPlans(DecoratedComponent, getAllAttPlans, fetchAttPlans, {
    is_upcoming: true,
  });
export const withSprintPlans = (DecoratedComponent) =>
  withPlans(DecoratedComponent, getAllPlans, fetchAllPlans);
export const withTracfonePlans = (DecoratedComponent) =>
  withPlans(DecoratedComponent, getAllTracfonePlans, fetchTracfonePlans);
export const withSimoPlans = (DecoratedComponent) =>
  withPlans(DecoratedComponent, getAllSimoPlans, fetchSimoPlans);
export const withQuickPlans = (DecoratedComponent) =>
  withPlans(DecoratedComponent, getAllQuickPlans, fetchQuickPlans);

export default withSprintPlans;
